import {
  home_hero_default
} from "./chunk-L4HMLQ7H.js";
import {
  card_stack_default
} from "./chunk-5QXIKYIN.js";

// src/modules/hero/hero.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var mHero = ({
  _id,
  className = "",
  content,
  labels,
  sequence
}) => {
  return /* @__PURE__ */ jsxs(
    "section",
    {
      className,
      "data-module-sequence": sequence,
      "data-module-type": "mHero",
      id: _id,
      children: [
        /* @__PURE__ */ jsx(
          home_hero_default,
          {
            image: content?.image,
            title: content?.title,
            video: content?.video
          }
        ),
        /* @__PURE__ */ jsx(card_stack_default, { id: `${_id}_hero`, labels, ...content })
      ]
    }
  );
};
var hero_default = mHero;

export {
  hero_default
};
